import { Component, ViewChild,OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import 'rxjs/add/operator/toPromise';
import { MatSidenav } from '@angular/material/sidenav';
import { CommonService } from '../../services/common/common.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
// import { Commons } from 'src/app/helpers/commons';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css']
})
export class MainNavComponent implements OnInit{

  durationInSeconds = 5;
  public user: any;
  public token: any;
  public userDetails: any;

  constructor(public router: Router,
    private breakpointObserver: BreakpointObserver,
    public comSer: CommonService,
    public auth: AuthService,
    public validator     : MatSnackBar,
    private spinnerService : NgxSpinnerService
    // public com: Commons,
  ) { }

ngOnInit(): void {

  let currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  this.userDetails = currentUser;
  this.getAllMenues();
}

// getAllMenues() {
//   this.comSer.getAllMenues(this.userDetails.userDetails).subscribe((res:any) =>{
//     let resData = res.data;

//     let filteredMenu = resData.filter((menuItem: { parent_details: { label: string } }) =>
//       menuItem.parent_details.label == 'Reports' || 
//       menuItem.parent_details.label == 'School'
//     );
    
//     let loopAppitems = [];
//     for(let i=0; i<resData.length;i++) {
//       //submenu
//       if(resData[i].submenu_details) { //if has sub menu
//         let subMenu: { label: any; link: any; icon: any; }[] = [];
//         resData[i].submenu_details.forEach((sub: { label: any; name: any; icon: any; }) => {
//           subMenu.push({
//               label: sub.label,
//               link:  '/'+sub.name,
//               icon: sub.icon
//           });

//         });
//         //main menu
//         loopAppitems[i] = {
//           label: resData[i].parent_details.label,
//           icon: resData[i].parent_details.icon,
//           hidden: false,
//           items: subMenu
//         };

//       } else { //if has no sub menu
//         //main menu
//         loopAppitems[i] = {
//           label: resData[i].parent_details.label,
//           icon: resData[i].parent_details.icon,
//           link: '/'+resData[i].parent_details.name,
//         };
//       }

//     }
//     this.appitems= loopAppitems;
//   },
//   error => {
//   });
// }

getAllMenues() {
  this.comSer.getAllMenues(this.userDetails.userDetails).subscribe((res: any) => {
    let resData = res.data;

    // ✅ Filter only School and Reports
    let filteredMenu = resData.filter((menuItem: { parent_details: { label: string } }) =>
      menuItem.parent_details.label === 'Reports' ||
      menuItem.parent_details.label === 'School'
    );

    let loopAppitems = [];
    for (let i = 0; i < filteredMenu.length; i++) {
      const item = filteredMenu[i];

      if (item.submenu_details && item.submenu_details.length > 0) {
        let subMenu: { label: any; link: any; icon: any; }[] = [];

        item.submenu_details.forEach((sub: { label: any; name: any; icon: any; }) => {
          subMenu.push({
            label: sub.label,
            link: '/' + sub.name.replace(/^\//, ''), // avoid double slash
            icon: sub.icon?.trim() || item.parent_details.icon
          });
        });

        loopAppitems.push({
          label: item.parent_details.label,
          icon: item.parent_details.icon?.trim(),
          hidden: false,
          items: subMenu
        });
      } else {
        loopAppitems.push({
          label: item.parent_details.label,
          icon: item.parent_details.icon?.trim(),
          link: '/' + item.parent_details.name.replace(/^\//, '')
        });
      }
    }

    this.appitems = loopAppitems;
  },
  error => {
    console.error('Menu load failed', error);
  });
}



isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );

otherTheme: any = localStorage.getItem("!otherTheme");

config = {
  paddingAtStart: true,
  classname: 'my-custom-class',
  listBackgroundColor: 'rgb(208, 241, 239)',
  fontColor: 'rgb(8, 54, 71)',
  backgroundColor: 'rgb(208, 241, 239)',
  selectedListFontColor: 'red',
};
appitems : any;


changeTheme() {
  this.otherTheme = !this.otherTheme;

  if (this.otherTheme == false) {
    localStorage.setItem("otherTheme", 'false');
  }
  else {
    localStorage.setItem("otherTheme", 'true');
  }
}

public logout() {
  this.spinnerService.show();
  localStorage.removeItem('currentUser');
  localStorage.removeItem('isLoggedIn');
  localStorage.clear();
  this.validator.open('Logout Successfully!', "ok",{
    duration: this.durationInSeconds * 1000,
    verticalPosition: 'top'
  });
  this.router.navigate(['/']);
  this.spinnerService.hide();
}


dashbboard() {
  this.router.navigate(['/dashboard']);
}

password() {
  this.router.navigate(['/auth/change-password']);
}

profile() {
  this.router.navigate(['/profile/user-profile']);
}

}
